

const tabdata = {
    state: {
        info: [],
    },
    mutations: {
        setInfo(state,arr){
            state.info=arr;
        }
    },
};

export default tabdata;